import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import AddIcon from '../../../../common/icons/ic_mas.svg';

const useStyles = makeStyles(() => ({
  button: {
    height: '100%',
    minHeight: '79px',
    width: '100%',
    borderRadius: 10,
  },
  image: {
    height: 29,
    width: 29,
    marginRight: 20,
  },
}));

const AddAddressButton = ({ ...props }) => {
  const { disabled, onClick } = props;
  const classes = useStyles();
  const handleClick = () => {
    onClick();
  };
  return (
    <Button
      variant="outlined"
      color="secondary"
      disabled={disabled}
      className={classes.button}
      onClick={handleClick}
      data-cy="addAddressButton"
    >
      <img src={AddIcon} className={classes.image} />
      Agregar dirección
    </Button>
  );
};

AddAddressButton.propTypes = {
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
};

export default AddAddressButton;
